export default function CheckRecovery(quiz_relations, grades) {
  console.log("CheckRecovery called with:", { quiz_relations, grades });
  
  const quizPairs = {
    1177: 1162,
    1162: 1177,
    1163: 1178,
    1178: 1163,
  };

  // Se não houver notas, não libera recuperação
  if (!grades || !grades.disciplina_grades) {
    console.log("No grades found, returning false");
    return false;
  }

  const nonRecoveryQuizzes = quiz_relations.filter(
    (relation) =>
      !relation.quizByQuiz.name.toUpperCase().includes("RECUPERAÇÃO")
  );

  // Verifica se existe alguma disciplina com nota < 7 E 3 tentativas esgotadas
  const shouldAllowRecovery = grades.disciplina_grades.some(grade => {
    const hasLowGrade = grade.grade < 7;
    const hasMaxAttempts = grade.attempts >= 3;
    
    console.log(`Discipline: ${grade.disciplina.name}, Grade: ${grade.grade}, Attempts: ${grade.attempts}, Low grade: ${hasLowGrade}, Max attempts: ${hasMaxAttempts}`);
    
    // Se tem nota baixa E fez 3 tentativas, libera recuperação
    if (hasLowGrade && hasMaxAttempts) {
      console.log(`Found discipline with low grade AND max attempts: ${grade.disciplina.name}`);
      return true;
    }
    
    return false;
  });

  if (shouldAllowRecovery) {
    console.log("Student has low grade with max attempts, returning true");
    return true;
  } else {
    console.log("No discipline found with low grade AND max attempts, returning false");
    return false;
  }
}
